import React, { useEffect, useState, useMemo, useCallback } from "react";
import { BsArrowLeftShort, BsSearch } from "react-icons/bs";
import { BiTable } from "react-icons/bi";
import { useMediaQuery, useTheme } from "@mui/material";
import { HiBarsArrowDown } from "react-icons/hi2";
import { IoClose } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import { Outlet, useNavigate, useLocation, useParams } from "react-router";
import { BiSolidDashboard } from "react-icons/bi";
import PropTypes from "prop-types";
import logo from "../../../assets/images/neophyte_logo_white.png";

const MenuItem = ({ menu, isOpen, isActive, onClick }) => {
  return (
    <li
      onClick={() => onClick(menu)}
      className={`text-xl flex items-center gap-x-4 p-2 py-2 my-2 hover:bg-[rgba(255,255,255,0.18)] rounded-md relative group ${
        menu.disabled === true
          ? "cursor-not-allowed text-gray-500"
          : "cursor-pointer text-white"
      }`}
    >
      <span
        className={`text-2xl block float-left ${
          isActive ? "text-cyan-400" : ""
        }`}
      >
        {menu.icon && menu.icon}
      </span>
      <span
        className={`text-base font-medium flex-1 duration-300 ${
          isActive ? "text-cyan-300" : ""
        } ${!isOpen && "hidden"}`}
      >
        {menu.title}
      </span>
      {!isOpen && (
        <div
          className={`absolute left-full rounded-md px-3 py-1 ml-10 bg-cyan-200 text-cyan-700 text-sm shadow-md -translate-x-3 transition-all invisible opacity-20 group-hover:opacity-100 group-hover:visible group-hover:translate-x-0`}
        >
          {menu.title}
        </div>
      )}
    </li>
  );
};

MenuItem.propTypes = {
  menu: PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.element.isRequired,
    disabled: PropTypes.bool,
    path: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

function NewStorePage() {
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [activeMenuItem, setActiveMenuItem] = useState("Overview");
  const [openMobileNavbar, setOpenMobileNavbar] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  // const store_id = localStorage.getItem("analysisStoreId");
  const { storeId } = useParams();

  
  const Menus = useMemo(
  () => [
    {
      title: "Overview",
      icon: <BiSolidDashboard />,
      disabled: false,
      path: `/main/stores/storeinsight/overview/${storeId}`,
    },
    {
      title: "Tableview",
      icon: <BiTable />,
      disabled: false,
      path: `/main/stores/storeinsight/tableview/${storeId}`,
    },
  ],
  [storeId]
);


  const handleMenuItemClick = useCallback(
    (menu) => {
      if (!menu.disabled && menu.path) {
        setActiveMenuItem(menu.title);
        navigate(menu.path);
      }
    },
    [navigate]
  );

  const handleMobileNavbarOpenClick = useCallback(() => {
    setOpenMobileNavbar((prev) => !prev);
  }, []);

  const filteredMenus = useMemo(() => {
    const query = searchQuery.toLowerCase();
    return Menus.filter((menu) => menu.title.toLowerCase().includes(query));
  }, [Menus, searchQuery]);

  useEffect(() => {
    const currentPath = location.pathname;
    const menuItem = Menus.find((menu) => currentPath.startsWith(menu.path));
    if (menuItem) {
      setActiveMenuItem(menuItem.title);
    }
  }, [location, Menus]);

  return (
    <div
      className="flex"
      style={{
        flexDirection: isLargeScreen ? "column" : "row",
        margin: isLargeScreen ? "0" : "-40px",
      }}
    >
      {!isLargeScreen ? (
        <div
          className={` h-[calc(100vh-64px)]  relative   ${
            open ? "w-96" : "w-24"
          }`}
        >
          <div
            className={` h-[calc(100vh-64px)]  fixed   ${
              open ? "w-72" : "w-24"
            }`}
          >
            <BsArrowLeftShort
              className={`bg-white text-cyan-950 ${
                open ? "-right-3 top-8" : "-right-3 top-8"
              } text-2xl rounded-full absolute  border border-gray-500 cursor-pointer border-dashed duration-1000 z-10  ${
                !open && "rotate-180"
              }`}
              onClick={() => setOpen(!open)}
            />
            <aside
              className={`bg-cyan-950 h-[calc(100vh-64px)] overflow-x-hidden overflow-y-auto scrollbar  p-5 pt-7 fixed duration-300 ${
                open ? "w-72 flex flex-col justify-between" : "w-24"
              }`}
            >
              <div>
                <div
                  onClick={() => {
                    if (!open) {
                      setOpen(!open);
                    }
                  }}
                  className={`flex relative group items-center cursor-pointer rounded-md bg-[rgba(255,255,255,0.18)] mt-4 py-2 ${
                    !open ? "px-2.5" : "px-4"
                  }`}
                >
                  <BsSearch
                    className={`text-white text-lg block  ml-2 cursor-pointer ${
                      open && "mr-4 ml-0"
                    }`}
                  />
                  <input
                    type={"search"}
                    placeholder="Search"
                    className={`text-base bg-transparent w-full text-white focus:outline-none ${
                      !open && "hidden"
                    }`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  {!open && (
                    <div
                      className={`absolute left-full rounded-md px-3 py-1 ml-10 bg-cyan-200 text-cyan-700 shadow-md -translate-x-3 transition-all invisible opacity-20 group-hover:opacity-100 group-hover:visible group-hover:translate-x-0`}
                    >
                      Search
                    </div>
                  )}
                </div>

                <ul
                  className={`pt-2   ${!open && "flex flex-col items-center "}`}
                >
                  {filteredMenus.map((menu) => (
                    <MenuItem
                      key={menu.title}
                      menu={menu}
                      isOpen={open}
                      isActive={activeMenuItem === menu.title}
                      onClick={handleMenuItemClick}
                    />
                  ))}
                </ul>
              </div>
              {open && (
                <div
                  className={`flex relative mt-7 flex-col pl-2.5 gap-0.5 bottom-1 transition-all ${
                    !open && "w-0"
                  }`}
                >
                  <span className="text-white text-sm">Powered by</span>
                  <img
                    src={logo}
                    alt="neophyte logo"
                    className="h-5 w-[170px]"
                  />
                  <span className="text-white text-sm">
                    Copyright Neophyte 2025
                  </span>
                </div>
              )}
            </aside>
          </div>
        </div>
      ) : (
        <div className="   w-full flex justify-start fixed top-3 -right-2 z-[5000]">
          <motion.div whileHover={{ scale: 1.2 }} className="border bg-white shadow-sm">
            <HiBarsArrowDown
              className="text-2xl hover:cursor-pointer  m-2"
              onClick={handleMobileNavbarOpenClick}
            />
          </motion.div>
          <AnimatePresence>
            {openMobileNavbar && (
              <motion.ul
                className="fixed z-[999] w-full h-full pt-5 bg-[#083344] right-0 top-14 flex flex-col gap-16 items-center overflow-y-auto scrollbar"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -50 }}
              >
                <motion.div
                  initial="initial"
                  animate="animate"
                  exit="exit"
                  variants={{
                    animate: {
                      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
                    },
                    exit: { transition: { staggerChildren: 0.1 } },
                  }}
                >
                  {Menus.map((menu, i) => (
                    <motion.li
                      key={i}
                      variants={{
                        initial: { opacity: 0, y: 20 },
                        animate: { opacity: 1, y: 0 },
                        exit: { opacity: 0, y: -20 },
                      }}
                      onClick={() => {
                        handleMenuItemClick(menu);
                        handleMobileNavbarOpenClick();
                      }}
                      className={`text-xl flex items-center gap-x-4 p-2 py-2 my-2 hover:bg-[rgba(255,255,255,0.18)] rounded-md relative group ${
                        menu.disabled === true
                          ? "cursor-not-allowed text-gray-500"
                          : "cursor-pointer text-white"
                      }`}
                    >
                      <span
                        className={`text-2xl block float-left ${
                          activeMenuItem === menu.title ? "text-cyan-400" : ""
                        }`}
                      >
                        {menu.icon && menu.icon}
                      </span>
                      <span
                        className={`text-2xl font-medium flex-1 duration-300 ${
                          activeMenuItem === menu.title ? "text-cyan-300" : ""
                        }`}
                      >
                        {menu.title}
                      </span>
                    </motion.li>
                  ))}
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  className="pb-10  mb-10 "
                >
                  <IoClose
                    className="text-3xl hover:cursor-pointer    text-slate-200"
                    onClick={handleMobileNavbarOpenClick}
                  />
                </motion.div>
              </motion.ul>
            )}
          </AnimatePresence>
        </div>
      )}
      <div
        className="mt-7 mx-5 w-full"
        style={{
          margin: isLargeScreen ? "0.5rem 0 0 0" : "1.9rem 1.25rem 0 1.25rem",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}

export default NewStorePage;
